import Vue from "vue";
import axios from "axios";

export const requestStatus = Vue.observable({
  pendingCount: 0,
  errorMessage: "",
  errorVisible: false,
});

let isInstalled = false;
let errorTimer = null;

function finishRequest() {
  requestStatus.pendingCount = Math.max(0, requestStatus.pendingCount - 1);
}

function getErrorMessage(error) {
  if (!error.response) {
    return "We couldn't reach the server. Please try again.";
  }

  if (error.response.data?.reason === "ACCOUNT_DISABLED") {
    return "Your account is disabled. Please contact your administrator.";
  }

  if (typeof error.response.data?.message === "string" && error.response.data.message.length > 0) {
    return error.response.data.message;
  }

  if (typeof error.response.data?.reason === "string" && error.response.data.reason.length > 0) {
    return error.response.data.reason.replaceAll("_", " ");
  }

  if (error.response.status >= 500) {
    return "Something went wrong on our side. Please try again.";
  }

  if (error.response.status === 404) {
    return "We couldn't find what you were looking for.";
  }

  if (error.response.status === 400) {
    return "That request could not be completed.";
  }

  return "Something went wrong. Please try again.";
}

function isAuthenticationRequest(error) {
  const url = error.config?.url || "";
  return url.includes("api/auth/session");
}

export function dismissRequestError() {
  requestStatus.errorVisible = false;
}

export function installRequestStatus() {
  if (isInstalled) return;

  isInstalled = true;

  axios.interceptors.request.use(
    function(config) {
      requestStatus.pendingCount += 1;
      return config;
    },
    function(error) {
      finishRequest();
      return Promise.reject(error);
    }
  );

  axios.interceptors.response.use(
    function(response) {
      finishRequest();
      return response;
    },
    function(error) {
      finishRequest();

      if (axios.isCancel(error)) return Promise.reject(error);

      if (error.response && error.response.status === 401) {
        if (!isAuthenticationRequest(error)) {
          window.location.href = "/";
        }

        return Promise.reject(error);
      }

      requestStatus.errorMessage = getErrorMessage(error);
      requestStatus.errorVisible = true;

      if (errorTimer) {
        window.clearTimeout(errorTimer);
      }

      errorTimer = window.setTimeout(() => {
        requestStatus.errorVisible = false;
      }, 6000);

      return Promise.reject(error);
    }
  );
}
